module.exports = __webpack_public_path__ + "static/media/Map1.88f530fa.jpg";